/**
 * Returns a local Date that displays the same UTC Y/M/D across timezones.
 * @param {Date|string} value - The date value
 * @returns {Date|undefined} The UTC display date
 * @author Abhishek Dhillon
 */
export const getUTCDate = (value) => {
  if (!value) return undefined;
  const dateObj = new Date(value);
  if (isNaN(dateObj.getTime())) return undefined;
  return new Date(dateObj.getUTCFullYear(), dateObj.getUTCMonth(), dateObj.getUTCDate());
};

/**
 * Converts a local date selection to a UTC date with the same Y/M/D.
 * @param {Date|string} value - The date value
 * @returns {Date|undefined} The UTC date
 * @author Abhishek Dhillon
 */
export const keepUtcDate = (value) => {
  if (!value) return undefined;
  const dateObj = new Date(value);
  if (isNaN(dateObj.getTime())) return undefined;
  let timeZoneOffset = dateObj.getTimezoneOffset() * 60 * 1000;
  if(timeZoneOffset > 0) {
    dateObj.setHours(0, 0, 0, 0);
    return new Date(dateObj.getTime());
  }
  dateObj.setHours(0, 0, 0, 0);
  return new Date(dateObj.getTime() + Math.abs(timeZoneOffset));
};